module.exports = __webpack_public_path__ + "static/assets/ee9e70cd96e5ccf839895058a8ead628.svg";